<template>
	<ion-page>
		<spot-header :title="pageTitle" :canGoHome="true" :showLogo="false" @pressedGoHome="$router.push('/home')"></spot-header>
		<ion-content :fullscreen="true">
			<ion-item v-if="!isActive || updatingLibraries">
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-if="isActive">
				<div id="fieldsContainer" class="content-rows"> <!--v-if="isActive"-->
					<web-socket-barcode @scanned="onScan"></web-socket-barcode>
					<div v-if="currField.id == field.movement_type">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="privateData.movement_types"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection">
						</spot-select>
					</div>
					<div v-if="currField.id == field.quantity">
						<spot-input
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:type="currField.inputType"
							:clearInput="true"
							:canUnlock="currField.canUnlock"
							@textChanged="changedInput"
							@committed="committedInput">
						</spot-input>
					</div>
					<div v-if="currField.id == field.employee">
						<spot-select-custom
							:ref="currField.name"
							:label="fields.list[field.movement_type].value.id == 0 ? receivingEmployee : shipmentEmployee"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="tablesData.employees"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							:custom-label="customEmployee"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addEmployee">
						</spot-select-custom>
					</div>
					<div v-if="currField.id == field.carrier">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="tablesData.carriers"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addCarrier">
						</spot-select>
					</div>
					<div v-if="currField.id == field.supplier">
						<spot-select
							:ref="currField.name"
							:label="fields.list[field.movement_type].value.id == 0 ? supplier : addressee"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="fields.list[field.movement_type].value.id == 0 ? tablesData.suppliers : tablesData.addressees"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="fields.list[field.movement_type].value.id == 0 ? addSupplier : addAddressee">
						</spot-select>
					</div>
					<div v-if="currField.id == field.item">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:options="tablesData.items"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addItem">
						</spot-select>
					</div>
					<div v-if="currField.id == field.tracking_number">
						<spot-input
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:type="currField.inputType"
							:clearInput="true"
							:canUnlock="currField.canUnlock"
							@textChanged="changedInput"
							@committed="committedInput">
						</spot-input>
					</div>
					<div v-if="currField.id == field.location">
						<spot-select
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed && !settings.insertMultiple.barcodeOnlyLocation"
							:value="currField.value"
							:options="tablesData.locations"
							:optionField="currField.refField"
							:canAddItem="currField.canAddItem"
							:canRefreshList="currField.canRefresh"
							:canUnlock="currField.canUnlock"
							selectedLabel="Selezionato"
							deselectLabel="rimuovi"
							selectLabel="seleziona"
							@selected="detectSelection"
							@unselected="detectUnselection"
							@addItem="addLocation">
						</spot-select>
					</div>
					<div v-if="currField.id == field.transport_document">
						<spot-input
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:type="currField.inputType"
							:clearInput="true"
							:canUnlock="currField.canUnlock"
							@textChanged="changedInput"
							@committed="committedInput">
						</spot-input>
					</div>
					<div v-if="currField.id == field.movement_header"> <!-- && settings.insertMultiple.autoSave == false -->
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<ion-button fill="outline" size="default" @click="createAndPrint()">
								{{ !currField.value ? (canPrint ? labelSave + labelAnd + labelPrint : labelSave) : (canPrint ? labelReprint : null) }}
								<ion-icon v-if="!currField.value" slot="icon-only" :icon="save" size="large"></ion-icon>
								<ion-icon v-if="canPrint" slot="icon-only" :icon="print" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
				</div>
				<div id="actionsContainer">
					<spot-button
						v-if="isVisibleButton(currField.canGoBack)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronBackCircleOutline"
						:enabled="currField.canGoBack && !fields.list[this.fields.list.length-1].value"
						:expand="null"
						:text=null
						@clicked="goBack()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canGoAhead)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronForwardCircleOutline"
						:enabled="!isDisableButton(currField.canGoAhead)"
						:expand="null"
						:text=null
						@clicked="goAhead()">
					</spot-button>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.global.debug">
				<div>Test Area</div>
				Current Field: {{ currField }}<br>
				<div v-for="element in fields.list" :key="element.id">
					{{ element.name }} = {{ element.value }}
				</div>
			</div>
		</ion-content>
	</ion-page>
</template>

<style src="vue-multiselect/dist/vue-multiselect.css"></style> <!--<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>-->
<style scoped>
	ion-label {
		font-weight:bold;
	}
	.content-rows {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		/*justify-content: space-around;*/
		/*align-content: flex-start;*/
		/*padding: 1em;*/
		/*height: 10%;*/
		/*overflow: auto;*/
	}
	.items-label {
		margin-top: .5em;
		margin-left: 1em;
	}
	.items-data {
		display: flex; /*inline-block;*/
		flex-direction: row;
		vertical-align: baseline;
		justify-content: space-between;
		text-align: left;
		margin-left: .5em;
		margin-right: .5em;
	}
</style>

<script>
	import WebSocketBarcode from "@/components/WebSocketBarcode.vue";
	import { IonButton, IonContent, IonIcon, IonItem, IonLabel, IonPage, IonSpinner } from "@ionic/vue";
	import { chevronBackCircleOutline, chevronForwardCircleOutline, print, save } from "ionicons/icons";
	import { defineComponent } from "vue";
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import SpotInput from "../components/SpotInput.vue";
	import SpotSelect from "../components/SpotSelect.vue";
	import SpotSelectCustom from "../components/SpotSelectCustom.vue";
	import { checkUserSession, insertValue, showMsgError, showMsgInfo, showMsgWarning } from "../plugins/common.js";
	import { settings } from "../plugins/settings.js";
	import { createAddressee, createCarrier, createEmployee, createItem, createLocation, createProject, createSupplier, executePrinterAction, getPrinter, searchLocations, tablesData } from '../plugins/customDatabase.js';

	export default defineComponent({
		name: "InsertMultiple",
		props: {
			pageTitle: { type: String, default: "Registrazione multipla" },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			loadingCarriersText: { type: String, default: "Caricamento Corrieri..." },
			loadingSuppliersText: { type: String, default: "Caricamento Fornitori..." },
			loadingAddresseesText: { type: String, default: "Caricamento Destinatari..." },
			loadingEmployeesText: { type: String, default: "Caricamento Dipendenti..." },
			loadingItemsText: { type: String, default: "Caricamento Formati..." },
			loadingLocationsText: { type: String, default: "Caricamento Ubicazioni..." },
			messageTitleSearchLocation: { type: String, default: "Ricerca Ubicazione" },
			messageWarningNotFoundLocation: { type: String, default: "Ubicazione non trovata" },
			labelPrint: { type: String, default: "Stampa" },
			labelReprint: { type: String, default: "Ristampa" },
			labelSave: { type: String, default: "Salva" },
			labelAnd: { type: String, default: " e " },
			receivingEmployee: { type: String, default: "Destinatario" },
			shipmentEmployee: { type: String, default: "Richiedente" },
			supplier: { type: String, default: "Mittente" },
			addressee: { type: String, default: "Destinatario" },
			newValueTitle: { type: String, default: "Inserimento Nuovo Valore" },
			messageTitleInsert: { type: String, default: "Creazione Sovracollo" },
			messageTitlePrint: { type: String, default: "Stampa Etichetta" },
			successSaveMessage: { type: String, default: "Sovracollo creato" },
			successMailMessage: { type: String, default: "E-mail inviata a: " },
			successPrintMessage: { type: String, default: "Stampa sovracollo avvenuta correttamente. Etichetta: " },
			errorPrintMessage: { type: String, default: "Errore durante la stampa del sovracollo" },
			warningPrinterOffline: { type: String, default: "La stampante non è raggiungibile; l'etichetta non è stata stampata" },
			unselected: { type: String, default: "Nessuno" },
		},
		components: {
			IonPage,
			IonButton,
			IonSpinner,
			IonItem,
			IonIcon,
			IonContent,
			IonLabel,
			SpotHeader,
			SpotSelect,
			SpotSelectCustom,
			SpotInput,
			SpotButton,
			WebSocketBarcode,
		},
		data: () => ({
			isActive: null,
			isClosed: null,
			header_id: null,
			header_code: null,
			spinnerText: null,
			updatingLibraries: null,
			field: {
				movement_type: 0,
				quantity: 1,
				employee: 2,
				carrier: 3,
				supplier: 4,
				item: 5,
				tracking_number: 6,
				location: 7,
				transport_document: 8,
				movement_header: 9,
			},
			fields: {
				currentId: 0,
				list: [
					//TODO: controlla il canSkip come è meglio metterlo (quando ho temrinato l'implementazione del modulo)
					{ id: 0, name: 'movement_type', text: 'Tipo Movimento', allignLabel: false, placeholder: 'Seleziona Tipo Movimento', refTable: null, inputType: "combo", defaultValue: null, value: null, required: true, refField: 'text', canAddItem: false, canSkip: true, canGoBack: false, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 1, name: 'quantity', text: 'Quantità', allignLabel: false, placeholder: 'Inserisci nr. Articoli', refTable: null, inputType: "number", defaultValue: null/*1*/, value: null, required: true, refField: null, canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 2, name: 'employee', text: 'Dipendente', allignLabel: false, placeholder: 'Seleziona Dipendente', refTable: 'employees', inputType: "combo", defaultValue: null/*1*/, value: null, required: true, refField: 'id', canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 3, name: 'carrier', text: 'Corriere', allignLabel: false, placeholder: 'Seleziona Corriere', refTable: 'carriers', inputType: "combo", defaultValue: null, value: null, required: false, refField: 'name', canAddItem: true, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 4, name: 'supplier', text: 'Mittente', allignLabel: false, placeholder: 'Seleziona Mittente', refTable: 'suppliers', inputType: "combo", defaultValue: null, value: null, required: false, refField: 'name', canAddItem: true, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 5, name: 'item', text: 'Formato', allignLabel: false, placeholder: 'Seleziona Formato Spedizione', refTable: 'items', inputType: "combo", defaultValue: null, value: null, required: false, refField: 'code', canAddItem: true, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 6, name: 'tracking_number', text: 'Track ID', allignLabel: false, placeholder: 'Inserisci ID Spedizione', refTable: null, inputType: "text", defaultValue: null, value: null, required: false, refField: null, canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 7, name: 'location', text: 'Ubicazione', allignLabel: false, placeholder: 'Seleziona Ubicazione', refTable: 'locations', inputType: "combo", defaultValue: null, value: null, required: false, refField: 'name', canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 8, name: 'transport_document', text: 'DDT', allignLabel: false, placeholder: 'Inserisci Nr. Documento di Trasporto', refTable: null, inputType: "text", defaultValue: null, value: null, required: false, refField: null, canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
					{ id: 9, name: 'movement_header', text: 'Salva e Stampa Sovracollo', allignLabel: false, placeholder: 'Salva e Stampa', refTable: null, inputType: "button", defaultValue: null, value: null, required: true/*false*/, canAddItem: false, canSkip: false, canGoBack: true, canGoAhead: true, canSave: false, canRefresh: false, canUnlock: false },
				],
			},
			privateData: {
				movement_types: [
					{ id: 0, name: 'Receipt', text: 'RICEZIONE', value: 'Receipt'},
					{ id: 1, name: 'Shipment', text: 'SPEDIZIONE', value: 'Shipment'},
				],
			},
			//showActionButtonsText : false,
			print,
			save,
			chevronBackCircleOutline,
			chevronForwardCircleOutline,
			settings,
			checkUserSession,
			insertValue,
			showMsgInfo,
			showMsgWarning,
			showMsgError,
			createAddressee,
			createCarrier,
			createEmployee,
			createItem,
			createLocation,
			createProject,
			createSupplier,
			executePrinterAction,
			getPrinter,
			searchLocations,
			tablesData,
		}),
		computed: {
			currField() {
				return this.fields.list[this.fields.currentId]
			},
			canPrint() {
				return (this.settings.global.printerManagement && this.tablesData.currentPrinter != null)
			}
		},
		async ionViewWillEnter() {
			await this.setDefault();
			await this.getAllTablesData();
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		watch: {
			currField() {
				if (this.settings.insertMultiple.autoSave && this.currField.id == this.field.movement_header) {
					this.saveRecord();
				}
			},
		},
		methods: {
			//Settings
			getPlaceHolder() {
				return ((this.settings.global.showFieldsPlaceholder) ? (this.currField.required ? this.currField.placeholder : this.unselected ) : '')
			},
			isDisableButton(ability) {
				if (this.settings.global.fieldsCheckOnButtons && ability) {
					return (this.currField.required && !this.currField.value) ? true : false
				}
				else {
					return !ability
				}
			},
			isVisibleButton(ability) {
				return (this.settings.global.hideUnneededButtons) ? ability : true
			},
			customEmployee ({ name, surname, department, seat, seat_code }) {
				let infoDepartment = "";
				if (department)
					infoDepartment = " (" + department.name + ")"
				else if (seat)
					infoDepartment = " (" + seat + ")"
				else if (seat_code)
					infoDepartment = " (" + seat_code + ")"
				return name + " " + surname + infoDepartment
			},
			//Database
			async getAllTablesData() {
				// Do Nothing
			},
			prepareNewProject() {
				if (this.fields.list[this.field.movement_type].value.id == 0)
					return this.prepareNewProjectReceipt();
				else 
					return this.prepareNewProjectShipment();
			},
			prepareNewProjectReceipt() {
				let myRecord = {
					project: {
						name: "MULTI",
						receiving: (this.fields.list[this.field.movement_type].value.id == 0) ? true : false,
						shipping: (this.fields.list[this.field.movement_type].value.id == 1) ? true : false,
						expected_project_rows_count: (this.fields.list[this.field.quantity].value) ? ((this.fields.list[this.field.quantity].value.length > 0) ? this.fields.list[this.field.quantity].value : null) : null,
						employee_id: (this.fields.list[this.field.employee].value) ? this.fields.list[this.field.employee].value.id : null,
						carrier_id: (this.fields.list[this.field.carrier].value) ? this.fields.list[this.field.carrier].value.id : null,
						supplier_id: (this.fields.list[this.field.supplier].value) ? this.fields.list[this.field.supplier].value.id : null,
						item_id: (this.fields.list[this.field.item].value) ? this.fields.list[this.field.item].value.id : null,
						tracking_number: (this.fields.list[this.field.tracking_number].value) ? ((this.fields.list[this.field.tracking_number].value.length > 0) ? this.fields.list[this.field.tracking_number].value : null) : null,
						location_id: (this.fields.list[this.field.location].value) ? this.fields.list[this.field.location].value.id : null,
						transport_document: (this.fields.list[this.field.transport_document].value) ? ((this.fields.list[this.field.transport_document].value.length > 0) ? this.fields.list[this.field.transport_document].value : null) : null,
						warehouse_id: this.tablesData.currentWarehouse.id,
						plant_id: this.tablesData.currentPlant.id,
					}
				};
				return myRecord;
			},
			prepareNewProjectShipment() {
				let myRecord = {
					project: {
						name: "MULTI",
						receiving: (this.fields.list[this.field.movement_type].value.id == 0) ? true : false,
						shipping: (this.fields.list[this.field.movement_type].value.id == 1) ? true : false,
						expected_project_rows_count: (this.fields.list[this.field.quantity].value) ? ((this.fields.list[this.field.quantity].value.length > 0) ? this.fields.list[this.field.quantity].value : null) : null,
						employee_id: (this.fields.list[this.field.employee].value) ? this.fields.list[this.field.employee].value.id : null,
						carrier_id: (this.fields.list[this.field.carrier].value) ? this.fields.list[this.field.carrier].value.id : null,
						addressee_id: (this.fields.list[this.field.supplier].value) ? this.fields.list[this.field.supplier].value.id : null,
						item_id: (this.fields.list[this.field.item].value) ? this.fields.list[this.field.item].value.id : null,
						warehouse_id: this.tablesData.currentWarehouse.id,
						plant_id: this.tablesData.currentPlant.id,
					}
				};
				return myRecord;
			},
			async saveRecord() {
				let direction = (this.fields.list[this.field.movement_type].value.id == 0) ? "DESTINATARIO:" : "MITTENTE:";
				let currEmployee = this.fields.list[this.field.employee].value.name + ` ` + this.fields.list[this.field.employee].value.surname;
				let mailMessage = "<br><br>" + this.successMailMessage + "&nbsp" + this.fields.list[this.field.employee].value.name + "&nbsp" + this.fields.list[this.field.employee].value.surname;
				this.tablesData.currentProject = null;
				await this.createProject(this.prepareNewProject(), false);
				if (this.tablesData.currentProject) {
					this.header_id = this.tablesData.currentProject.id;
					this.header_code = this.tablesData.currentProject.code;
					this.currField.value = true;
					if (this.canPrint) {
						await this.getPrinter(this.tablesData.currentPrinter.id);
						if (this.tablesData.currentPrinter.is_online == true) {
							await this.executePrinterAction(`printers/` + this.tablesData.currentPrinter.id + `?do=print_single_barcode` + `&barcode=` + this.header_code + `&direction=` + direction + `&employee=` + currEmployee + `&datetime=` + new Date().toLocaleString("it-IT"))
							.then(() => {
								this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage + mailMessage + "<br><br>" + this.successPrintMessage + "&nbsp" + this.header_code);
								if (this.settings.insertMultiple.autoSave == true) this.goAhead();
							})
							.catch(error => {
								this.checkUserSession(error, "warning");
								this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
							})
						}
						else {
							this.showMsgWarning(this.messageTitleInsert, this.successSaveMessage + mailMessage + "<br><br>" + this.warningPrinterOffline);
						}
					}
					else {
						this.showMsgInfo(this.messageTitleInsert, this.successSaveMessage + mailMessage);
						this.goAhead();
					}
				}
			},
			//Actions
			onScan(barcode) {
				if(this.isActive == true) {
					switch (this.currField.id) {
						case this.field.tracking_number:
						case this.field.transport_document:
							this.currField.value = barcode
							this.committedInput()
							break;
						case this.field.location:
							this.currField.value = this.tablesData.locations.find(element => element.code == barcode);
							if (!this.currField.value) {
								this.showMsgWarning(this.messageTitleSearchLocation, this.messageWarningNotFoundLocation);
							} else {
								this.committedInput()
							}
							break;
						default:
							// this.showMsgWarning("Barcode","non è ammessa la lettura di barcode")
					}
				}
			},
			async setDefault() {
				this.spinnerText = this.defaultSpinnerText;
				this.fields.currentId = 0;
				this.fields.list.forEach(element => element.value = element.defaultValue);
				this.header_id = null;
				this.header_code = null;
				this.updatingLibraries = false;
			},
			detectReturn(keyCode) {
				if (keyCode == 13) setTimeout(() => this.goAhead(), 0);
			},
			changedInput(value) {
				this.currField.value = value;
			},
			committedInput() {
				setTimeout(() => this.goAhead(), 0);
			},
			detectSelection(value) {
				this.currField.value = value;
				if (this.settings.global.nextFieldOnComboSelect) setTimeout(() => this.goAhead(), 0);
			},
			detectUnselection() {
				this.currField.value = this.currField.defaultValue;
			},
			goBack() {
				if (this.fields.currentId >= 0 ) {
					if (this.fields.list[this.field.movement_type].value.id == 1 && (this.fields.currentId == this.fields.list.length-1)) this.fields.currentId = this.field.item;
					else this.fields.currentId-=1;
				}
			},
			goAhead() { //TODO: Queste sono da modificare per gestire la diversità tra ricezione e spedizione
				if (this.fields.currentId < (this.fields.list.length-1) ) {
					if (this.fields.list[this.field.movement_type].value.id == 1 && (this.fields.currentId == this.field.item)) this.fields.currentId = this.fields.list.length-1;
					else this.fields.currentId+=1
				}
				else this.executeLastFieldAction()
			},
			goToPrint() {
				if (this.fields.currentId >= 0 && this.fields.currentId < (this.fields.list.length-1) ) this.fields.currentId = this.fields.list.length-1
			},
			async addCarrier() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						carriers: {
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingCarriersText;
					await this.createCarrier(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentCarrier;
				}
			},
			async addSupplier() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.supplier)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						suppliers: {
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingSuppliersText;
					await this.createSupplier(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentSupplier;
				}
			},
			async addAddressee() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.addressee)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						addressees: {
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingAddresseesText;
					await this.createAddressee(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentAddressee;
				}
			},
			async addEmployee() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						employees: {
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingEmployeesText;
					await this.createEmployee(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentEmployee;
				}
			},
			async addItem() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						items: {
							code: fieldValue,
							location_id: 1,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingItemsText;
					await this.createItem(myRecord);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentItem;
				}
			},
			async addLocation() {
				let fieldValue = null;
				await this.insertValue(this.newValueTitle, this.currField.text)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue) {
					let myRecord = {
						locations: {
							warehouse_id: this.tablesData.currentWarehouse.id,
							code: fieldValue,
							name: fieldValue,
						}
					}
					this.updatingLibraries = true;
					this.spinnerText = this.loadingLocationsText;
					await this.createLocation(myRecord, false);
					await this.searchLocations(this.tablesData.currentWarehouse.id);
					this.updatingLibraries = false;
					this.currField.value = this.tablesData.currentLocation;
				}
			},
			async createAndPrint() {
				if (!this.currField.value) {
					this.saveRecord();
				}
				else {
					let direction = "";
					let currEmployee = this.fields.list[this.field.employee].value.name + ` ` + this.fields.list[this.field.employee].value.surname;
					if (this.fields.list[this.field.movement_type].value.id == 0) direction = "DESTINATARIO:";
					if (this.fields.list[this.field.movement_type].value.id == 1) direction = "MITTENTE:";
					if (this.canPrint) {
						await this.getPrinter(this.tablesData.currentPrinter.id);
						if(this.tablesData.currentPrinter.is_online == true) {
							await this.executePrinterAction(`printers/` + this.tablesData.currentPrinter.id + `?do=print_single_barcode` + `&barcode=` + this.header_code + `&direction=` + direction + `&employee=` + currEmployee + `&datetime=` + new Date().toLocaleString("it-IT"))
							.then(() => {
								this.showMsgInfo(this.messageTitlePrint,this.successPrintMessage + "&nbsp" + this.header_code);
							})
							.catch(error => {
								this.checkUserSession(error, "warning");
								this.showMsgError(this.messageTitlePrint, this.errorPrintMessage);
							})
						}
						else {
							this.showMsgWarning(this.messageTitlePrint,this.warningPrinterOffline);
						}
					}
				}
			},
			executeLastFieldAction() {
				if (this.settings.global.fieldsCheckOnButtons == true) {
					this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
					//TODO: aggiungi checkUserSession (ma non dovrebbe mai arrivarci)
				}
			},
		},
	});
</script>
